<template>
  <div class="home">
    <section class="hero is-danger is-fullheight-with-navbar">
      <div class="hero-body">
        <div class="">
          <p class="title">
            The Perfumers
          </p>
          <p class="subtitle">
            We will find a perfume that will be your soul mate.
          </p>
          <router-link to="/test" class="button is-outlined">Let's Findout!</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
  name: 'Home',
  components: {

  }
}
</script>
